import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "banners-list-section"
}
const _hoisted_2 = { class: "banners-list-rows" }
const _hoisted_3 = {
  key: 0,
  class: "banners-list-row-column full-column"
}
const _hoisted_4 = ["src", "onClick"]
const _hoisted_5 = {
  key: 1,
  class: "banners-list-row-column full-column"
}
const _hoisted_6 = {
  key: 0,
  class: "banners-list-slide"
}
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = {
  key: 1,
  class: "banners-list-slide-hide"
}
const _hoisted_9 = {
  key: 1,
  class: "banners-list-section"
}
const _hoisted_10 = { class: "banners-list-rows" }
const _hoisted_11 = { class: "banners-list-row" }
const _hoisted_12 = { class: "banners-list-row-column full-column" }

export function render(_ctx, _cache) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_q_skeleton = _resolveComponent("q-skeleton")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoading && _ctx.bannersListAfterHandle.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannersListAfterHandle, (banner, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "banners-list-row",
                key: `bannersList${index}`
              }, [
                (banner.bannerLayout !== 'sidebyside')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (banner.marketingBannerFragment.length === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("img", {
                              src: banner.marketingBannerFragment[0].bannerImage._publishUrl,
                              onClick: $event => (_ctx.openUrl(banner.marketingBannerFragment[0]))
                            }, null, 8, _hoisted_4)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_swiper, {
                              modules: _ctx.modules,
                              "centered-slides": true,
                              pagination: _ctx.optionSwiper.pagination,
                              autoplay: _ctx.setDuration(banner.displayDuration)
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(banner.marketingBannerFragment, (slide, index) => {
                                  return (_openBlock(), _createBlock(_component_swiper_slide, {
                                    class: "banners-list-swiper-slide",
                                    key: `bannersListSlide${index}`
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.stateAutoplay)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createElementVNode("img", {
                                              src: slide.bannerImage._publishUrl,
                                              onClick: $event => (_ctx.openUrl(slide))
                                            }, null, 8, _hoisted_7)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_8, "Slide"))
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modules", "pagination", "autoplay"])
                          ]))
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_q_skeleton, {
                  class: "skeleton-img",
                  height: "17.55vh"
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}